import { Optional } from "common/utils/types";
import Image from "common/components/Image";

import Header from "client/common/components/header/Header";
import { useClinic } from "client/clinics/hooks";

import HomeContent from "../HomeContent";
import thriveAnimals from "../../images/thrive-animals.webp";

import styles from "../../styles/HomeThemeThrive.module.less";

const accentColor = "#74D704";

type HomeThemeThriveProps = {
  storefrontThemeConfig: { logo: Optional<string> };
};

/** Like the hero theme but customized for thrive. */
const HomeThemeThrive = ({ storefrontThemeConfig }: HomeThemeThriveProps) => {
  const clinic = useClinic();
  const { logo } = storefrontThemeConfig;

  return (
    <div>
      <div className={styles.theme}>
        <Header
          styles={{
            menuIcon: styles.menuIcon,
            nav: styles.nav,
            cartButton: styles.cartButton,
          }}
          storefrontThemeLogo={logo}
          bannerVariant="default"
          hasWhiteIcons={false}
        />
        <HomeContent.Header>
          <div className={styles.header}>
            <div className={styles.contentHeader}>
              <HomeContent.Title className={styles.title} lineColors={accentColor} />
              <div className={styles.description}>
                Your animal&apos;s health is our top priority at {clinic.display_name}. We&apos;ve
                made it even easier to refill and request new medications through our online store.
              </div>
            </div>
            <Image src={thriveAnimals} alt="Thrive Animals" className={styles.animals} />
          </div>
        </HomeContent.Header>
      </div>
      <HomeContent.Body hasLoggedinSummary={true} hasRoundedTop={false} />
    </div>
  );
};

export default HomeThemeThrive;
